// extracted by mini-css-extract-plugin
export default {"root":"_3i19z","small":"_2jB9o","normal":"_2XCNT"};